import {
  ArrowUpward,
  Code,
  Description,
  GitHub,
  Language,
  LanguageOutlined,
  Login,
  Settings,
  StorageOutlined,
  SyncAlt,
} from "@mui/icons-material";
import AppsIcon from "@mui/icons-material/Apps";
import ArticleRoundedIcon from "@mui/icons-material/ArticleRounded";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import BadgeIcon from "@mui/icons-material/Badge";
import CloudIcon from "@mui/icons-material/Cloud";
import ComputerIcon from "@mui/icons-material/Computer";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import DiamondIcon from "@mui/icons-material/Diamond";
import DnsIcon from "@mui/icons-material/Dns";
import DomainRoundedIcon from "@mui/icons-material/DomainRounded";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import GroupIcon from "@mui/icons-material/Group";
import LanRoundedIcon from "@mui/icons-material/LanRounded";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PasswordIcon from "@mui/icons-material/Password";
import PermIdentityRoundedIcon from "@mui/icons-material/PermIdentityRounded";
import PolicyIcon from "@mui/icons-material/Policy";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import RuleIcon from "@mui/icons-material/Rule";
import StorageIcon from "@mui/icons-material/Storage";
import TokenIcon from "@mui/icons-material/Token";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

const descriptorToMUIbyCategory = {
  misc: {
    default: Description,
    Execution: Code,
  },
  phase: {
    Infiltration: Login,
    "Lateral Movement": SyncAlt,
    "Privilege Escalation": ArrowUpward,
  },
  threat: {
    "Data Breach": StorageOutlined,
    Ransomware: LockOutlinedIcon,
    "Supply Chain": LinkOutlinedIcon,
  },

  entity: {
    data_store: DnsIcon,
    role: BadgeIcon,
    server: StorageIcon,
    group: GroupIcon,
    iamGroup: GroupIcon,
    policy: PolicyIcon,
    user: PermIdentityRoundedIcon,
    iamUser: PermIdentityRoundedIcon,
    gitHubUser: PermIdentityRoundedIcon,
    github_organization: GroupIcon,
    rule: RuleIcon,
    app: AppsIcon,
    host: ComputerIcon,
    okta_token: TokenIcon,
    google_token: TokenIcon,
    behavior: QuestionMarkIcon,
    resource: AutoStoriesIcon,
    brand: WorkspacePremiumIcon,
    domain: DomainRoundedIcon,
    org: LanRoundedIcon,
    aws_secret: PasswordIcon,
    website: LanguageOutlined,
    account: CloudIcon,
    scope: Language,
    asset: DiamondIcon,
    organization: CorporateFareIcon,
    repository: GitHub,
    admin_user: PermIdentityRoundedIcon,
    resource_set: AutoStoriesIcon,
    directory: FolderOpenIcon,
    entra_id_directory: FolderOpenIcon,
    plan: WorkspacePremiumIcon,
    prestage_enrollment: Settings,
    origin: LanguageOutlined,
    device: ComputerIcon,
    okta_app: AppsIcon,
    jamf_user: PermIdentityRoundedIcon,
    edr_app: AppsIcon,
    greenhouse_candidate: PermIdentityRoundedIcon,
    atlassian_app: AppsIcon,
    user_drive: PermIdentityRoundedIcon,
    shared_drive: FolderOpenIcon,
    device_volume: StorageIcon,
    snowflake_user: PermIdentityRoundedIcon,
    jumpcloud_user: PermIdentityRoundedIcon,
    document: ArticleRoundedIcon,
    device_profile: PolicyIcon,
    dns_record: DnsIcon,
  },
};

const descriptorToIconFromMUI = Object.entries(
  descriptorToMUIbyCategory
).reduce((acc, [key, value]) => {
  return { ...acc, ...value };
}, {});

export default descriptorToIconFromMUI;
